
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.6957 11.8531C19.031 8.60201 15.7016 6.57497 12 6.57497C8.29844 6.57497 4.96899 8.60201 3.30427 11.8531C3.2553 11.951 3.2553 12.0588 3.30427 12.1469C4.96899 15.4078 8.30823 17.425 12 17.425C15.6918 17.425 19.031 15.4078 20.6957 12.1469C20.7447 12.049 20.7447 11.9413 20.6957 11.8531ZM1.72768 11.0501C3.62742 7.34857 7.51504 4.81232 12 4.81232C16.4948 4.81232 20.3726 7.34857 22.2723 11.0501C22.5759 11.6475 22.5759 12.3525 22.2723 12.9499C20.3726 16.6514 16.4948 19.1877 12 19.1877C7.50525 19.1877 3.62742 16.6514 1.72768 12.9499C1.42411 12.3525 1.42411 11.6475 1.72768 11.0501ZM11.4124 15.9953C14.262 16.3968 16.622 13.841 15.8974 10.9424H15.9072C15.4371 9.09163 13.7626 7.90674 11.8531 7.97529C11.5593 7.98508 11.2851 8.02425 11.0109 8.10259V9.86524C11.0109 10.4038 10.5703 10.8445 10.0317 10.8445H8.14172C7.98504 11.3635 7.92628 11.9412 8.00462 12.5484C8.22985 14.3012 9.65955 15.7505 11.4124 15.9953Z","fill":"#16171F"}})])
          )
        }
      }
    